import * as React from 'react';
import { AppContext } from '../../Context/app-state';
import { TSizes } from '../../Data/data';
import './Filter-Value.css';

export default function FilterValue() {
  const { filters, setFilters } = React.useContext(AppContext);
  const { big, average, small } = filters.size;

  const handleSizeChange = (event: React.MouseEvent<HTMLElement>) => {
    const checkedSize = (event.target as Element).id as TSizes;
    setFilters({
      ...filters,
      size: { ...filters.size, [checkedSize]: !filters.size[checkedSize] },
    });
  };

  return (
    <div className="filter-size" onClick={handleSizeChange}>
      Размер:
      <div className={`size-big ${big ? 'active' : ''}`}>
        <img id="big" src="./assets/svg/ball.svg" alt="" />
      </div>
      <div className={`size-average ${average ? 'active' : ''}`}>
        <img id="average" src="./assets/svg/ball.svg" alt="" />
      </div>
      <div className={`size-small ${small ? 'active' : ''}`}>
        <img id="small" src="./assets/svg/ball.svg" alt="" />
      </div>
    </div>
  );
}
